import React, { useState } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

const SubuserInvoiceTableDropdown = ({
  data,
  setToggleModal,
  setDataModal,
  disabled
}) => {
  const [dropdownOpen, setOpen] = useState(false);
  const toggle = () => setOpen(!dropdownOpen);

  return (
    <ButtonDropdown isOpen={dropdownOpen} toggle={toggle} disabled={disabled}>
      <DropdownToggle caret outline color="primary">
        Action
      </DropdownToggle>
        <DropdownMenu>
          <DropdownItem
            disabled={data.status !== 0 || disabled}
            onClick={() => {
              setDataModal({
                invoice_id: data.id,
                status: 1
              });
              setToggleModal(true);
            }}
            style={{ cursor: "pointer" }}
          >
            Mark as Accepted
          </DropdownItem>
          <DropdownItem
            disabled={data.status !== 0 || disabled}
            onClick={() => {
              setDataModal({
                invoice_id: data.id,
                status: 2
              });
              setToggleModal(true);
            }}
            style={{ cursor: "pointer" }}
          >
            Mark as Rejected
          </DropdownItem>
          <DropdownItem
            disabled={data.status !== 1 || disabled}
            onClick={() => {
              setDataModal({
                invoice_id: data.id,
                status: 3
              });
              setToggleModal(true);
            }}
            style={{ cursor: "pointer" }}
          >
            Mark as Paid
          </DropdownItem>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default SubuserInvoiceTableDropdown;
